import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import pages from "../seo-pages.json";
export default function SeoMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, "") || "/";
    const page = pages[path];
    if (!page) return;
    document.title = page[0];
    document.querySelector('meta[name="description"]').setAttribute("content", page[1]);
    document.querySelector('link[rel="canonical"]').setAttribute("href", "https://epaging.net" + path);
    for (const [property, content] of [["og:title", page[0]], ["og:description", page[1]], ["og:url", "https://epaging.net" + path]]) {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) { tag = document.createElement("meta"); tag.setAttribute("property", property); document.head.appendChild(tag); }
      tag.setAttribute("content", content);
    }
  }, [pathname]);
  return null;
}
